<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Rename Item</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div *ngIf="!hasError" class="alert alert-info py-2 small">
    The following characters will be removed from the name: \ / : * ? " &lt; &gt; |
  </div>

  <div *ngIf="hasError" class="alert alert-danger py-2">
    {{errorMessage}}
  </div>

  <div class="mb-3">
    <label class="form-label fw-semibold">New Name</label>
    <input class="form-control" [(ngModel)]="newName" (change)="validateForm()" autocomplete="off">
  </div>

</div>

<div class="modal-footer">

  <button *ngIf="!loading" type="button" class="btn btn-success"
    [disabled]="renameDisabled" (click)="renameItem()">OK</button>

  <button *ngIf="loading" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Renaming...
  </button>
</div>